export default __webpack_public_path__ + "static/banner-travel-done-better-e71969260199953929f40eaff8cbe8cb.jpg";